// extracted by mini-css-extract-plugin
export default {"container":"PaletteCategoryList_container__8OaYi","name":"PaletteCategoryList_name__fWQXu","list":"PaletteCategoryList_list__9oG8O"};